import Icon from '../components/Icon.vue'

Icon.register({
  'grin-stars': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM94.6 168.9L129.5 163.9 145 132.3C147.9 126.5 156 126.5 158.9 132.3L174.4 163.9 209.3 168.9C215.5 169.9 218.2 177.5 213.6 182.1L188.2 206.7 194.2 241.6C195.2 247.8 188.9 252.6 183.2 249.5L152 233.3 120.7 249.6C115 252.7 108.7 247.9 109.7 241.7L115.7 206.8 90.3 182.2C85.7 177.5 88.4 169.9 94.6 168.9zM248 432C187.4 432 113.5 393.7 104.2 338.7 102.2 326.9 113.5 317.2 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.6 317.1 393.7 326.9 391.8 338.7 382.5 393.7 308.6 432 248 432zM405.7 182.1L380.3 206.7 386.3 241.6C387.3 247.8 381 252.6 375.3 249.5L344 233.3 312.7 249.6C307 252.7 300.7 247.9 301.7 241.7L307.7 206.8 282.3 182.2C277.8 177.6 280.4 170 286.6 169L321.5 164 337 132.4C339.9 126.6 348 126.6 350.9 132.4L366.4 164 401.3 169C407.6 169.9 410.3 177.5 405.7 182.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-stars.js
// module id = Zh1k
// module chunks = 144